import { useForceUpdate } from "@fluentui/react-hooks";

import { get, save } from "API/LocalStorage";
import { useCallback, useEffect, useState } from "react";
import { IUseTeach } from "./IUseTeach";

export function useTeach(token: string, show: boolean): IUseTeach {
  const isTeachDisabled = get<boolean>(`${token}.hide`) ?? false;
  const [showTeach, setShowTeach] = useState(!isTeachDisabled && (show ?? true));
  const forceUpdate = useForceUpdate();

  useEffect(() => {
    setShowTeach(!isTeachDisabled && show);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const onDismiss = useCallback((ev?: Event) => {
    if (ev?.type === `scroll`) {
      forceUpdate();
      return;
    }
    setShowTeach(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onHide = useCallback(() => {
    onDismiss();
    save<boolean>(`${token}.hide`, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    showTeach,
    onHide,
    onDismiss
  };
}
